<script setup lang="ts">
import InformationContainer from '@components/ui/auto-reserve&gift-card&index/InformationContainer.vue';
import { ReserveType } from '@utils/itinerary';

const { setReserveType } = useSearchFormStore();
useServerHead({
    link: [
        {
            rel: 'canonical',
            href: 'https://mrbilit.com/taxi',
        },
    ],
});

onMounted(() => setReserveType(ReserveType.Taxi));
definePageMeta({
    breadcrumbs: JSON.stringify([
        { title: 'مِستربلیط', link: '/' },
        { title: 'بلیط سواری', link: '$routePath' },
    ]),
});
</script>

<template>
    <InformationContainer />
</template>
